import styled, { css } from 'styled-components';
import type { PtoVolumePosition } from '@shared/api';
import type { VolumeCellContext, VolumeColumn } from './columns';
import { volumeRowDomId } from './rowRef';

const TrReview = styled.tr<{ $review: boolean; $target: boolean }>`
  background: ${({ $review, $target, theme }) =>
    $target
      ? `${theme.colors.status.warning}29`
      : $review
        ? theme.colors.primarySoft
        : 'transparent'};
  ${({ $target, theme }) =>
    $target &&
    css`
      & > td:first-child {
        box-shadow: inset 3px 0 0 ${theme.colors.status.warning};
      }
    `}
`;

interface Props {
  position: PtoVolumePosition;
  columns: VolumeColumn[];
  ctx: VolumeCellContext;
  /** Строка открыта по ссылке (`#pos=…&uid=…`) — подсвечена. */
  target: boolean;
}

/** Строка позиции: ячейки по графам `columns`; позиция на проверке подсвечена фоном,
 *  строка из ссылки — своей подсветкой. */
export function VolumeRow({ position, columns, ctx, target }: Props) {
  return (
    <TrReview
      id={volumeRowDomId(position.id)}
      $review={position.needs_review}
      $target={target}
      aria-current={target ? 'location' : undefined}
    >
      {columns.map((c) => (
        <td key={c.key} className={c.num ? 'num' : undefined}>
          {c.cell(position, ctx)}
        </td>
      ))}
    </TrReview>
  );
}
